/**
 * DS-internal hook : le système demande-t-il moins d'animation ?
 *
 * `prefers-reduced-motion: reduce` sur le web, « Réduire les animations » sur iOS et Android —
 * react-native(-web) répond aux deux par le même `AccessibilityInfo`. Un composant animé lit ce
 * drapeau pour passer ses durées à zéro : le livre veut « le résultat arrive », pas le mouvement
 * pour lui-même.
 */
import { useEffect, useState } from "react"
import { AccessibilityInfo } from "react-native"

export function useReduceMotion(): boolean {
    const [reduceMotion, setReduceMotion] = useState(false)

    useEffect(() => {
        let alive = true
        AccessibilityInfo.isReduceMotionEnabled().then((on) => {
            if (alive) setReduceMotion(on)
        })
        const sub = AccessibilityInfo.addEventListener("reduceMotionChanged", setReduceMotion)
        return () => {
            alive = false
            sub.remove()
        }
    }, [])

    return reduceMotion
}
